import { graphql } from 'msw';

const exampleHandlers = [
  graphql.query('GetExample', (req, res, ctx) => {
    return res(ctx.data({ payload: 'some payload' }));
  }),
  graphql.mutation('CreateExample', (req, res, ctx) => {
    return res(ctx.data({ payload: req.variables.payload }));
  }),
];

export default exampleHandlers;
